export const SortOrder = {
  UNSORTED: 0,
  ASC: 1,
  DESC: 2,
};
